import * as THREE from 'three';
import { G, M, TINT, HP, glowMat, mesh, bevel, plate, rib, seam, joint, ram, mergeBones, damp, angTo, legIK, LB1, LB2, LBF } from './kit';
/* ============================================================
   WALZE 軋輥 —— BOSS・地面壓迫
   ============================================================

   剪影：四足頂起的方形量體＋前犁


   由 `tools/port-bosses.mjs` 從 `enemy_sample_ani.html` 機械移植，
   **不要手改這個檔**：要改造型請改原型再重跑移植器，否則 1:1 就斷了。
   驗證：`node tools/port-bosses.mjs --check`。
   ⚠️ 比對只守得住數字與字串，**動畫對不對只能實看**（圖鑑的開發模式）。 */


/* BOSS-01 WALZE 軋輥 —— 四足重戰車。
   剪影：一塊被四根反關節腿頂起來的方形量體，前面掛一片犁。
   讀法：紅＝牠靠撞；但砲塔是橙的＝那一發是直射。同一隻身上兩種威脅
   用兩個顏色分開講，玩家才知道該閃哪一個。 */
function walzeLeg(sx, sz, GL){
  var hip = new THREE.Group();
  hip.position.set(sx*1.16, 0, sz*0.98);
  hip.rotation.y = -sx*0.05;
  hip.add(joint(0.27, [0,0,0], true));

  var thigh = new THREE.Group(); thigh.userData.bone = 1; hip.add(thigh);
  thigh.add(bevel(M.dark,  0.52, 0.90, 0.52, [0,-0.44,0]));
  thigh.add(plate(M.armor, 0.62, 0.84, 0.24, [0,-0.42, sz*0.32], -0.06, 0, sx*0.10));
  thigh.add(rib  (M.armor, 0.09, 0.80, 0.09, [sx*0.30,-0.44, sz*0.16], 0));
  thigh.add(ram  ([sx*0.32,-0.62, sz*0.30], 0.72, 0.12, 0.10, [-0.12,0,0]));

  var knee = new THREE.Group(); knee.position.y = -LB1; thigh.add(knee);
  knee.add(joint(0.23, [0,0,0], true));
  var kg = mesh(G.oct, GL, [0.22,0.22,0.22], [sx*0.26, 0, 0]);   // 弱點：膝
  kg.userData.noMerge = 1; knee.add(kg);

  var shin = new THREE.Group(); shin.userData.bone = 1; knee.add(shin);
  shin.add(bevel(M.dark,  0.42, 0.82, 0.44, [0,-0.40,0]));
  shin.add(plate(M.armor, 0.48, 0.72, 0.22, [0,-0.36,-sz*0.28], 0.10));
  shin.add(rib  (M.armor, 0.07, 0.66, 0.07, [0,-0.38, sz*0.24], -0.06));

  var ank = new THREE.Group(); ank.position.y = -LB2; shin.add(ank);
  ank.add(joint(0.18, [0,0,0]));
  var foot = new THREE.Group(); foot.userData.bone = 1; ank.add(foot);
  foot.add(mesh (G.box,  M.trim,  [0.48,0.15,0.90], [0,-0.09, sz*0.18]));
  foot.add(plate(M.armor,0.42,0.14,0.42, [0,-0.01, sz*0.40], -0.10));
  foot.add(mesh (G.cone, M.trim,  [0.24,0.32,0.24], [0,-0.14, sz*0.50], [Math.PI,0,0]));
  return {root:hip, thigh:thigh, shin:shin, foot:foot, kneeGlow:kg, sx:sx, sz:sz, dead:0};
}
export function buildWalze(){
  var GL  = glowMat(TINT.red.hex, 1.8);
  var GLA = glowMat(TINT.amb.hex, 2.0);
  var root = new THREE.Group();
  var body = new THREE.Group(); body.userData.bone = 1; body.position.y = 1.78; root.add(body);

  body.add(bevel(M.dark,  2.10, 0.74, 2.56, [0,0,0]));
  body.add(plate(M.armor, 2.26, 0.48, 1.34, [0, 0.44, 0.60], -0.36));
  body.add(plate(M.armor, 2.12, 0.42, 1.12, [0, 0.42,-0.66],  0.30));
  body.add(rib  (M.armor, 2.32, 0.11, 0.11, [0, 0.70, 0.30], -0.36));
  body.add(seam (2.00, 0.07, 0.10, [0, 0.30, 0.94], -0.36));
  body.add(plate(M.armor, 0.30, 0.74, 2.24, [ 1.14,-0.12, 0], 0, -0.12, -0.18));
  body.add(plate(M.armor, 0.30, 0.74, 2.24, [-1.14,-0.12, 0], 0,  0.12,  0.18));
  body.add(rib  (M.armor, 0.10, 0.10, 2.20, [ 1.22, 0.22, 0], 0, -0.12));
  body.add(rib  (M.armor, 0.10, 0.10, 2.20, [-1.22, 0.22, 0], 0,  0.12));
  /* 前犁：BOSS 的「牠會直接輾過來」全部靠這一片講 */
  body.add(plate(M.armor, 2.04, 0.92, 0.34, [0,-0.14, 1.42], -0.64));
  body.add(mesh (G.cone,  M.trim,  [0.36,0.74,0.36], [ 0.68,-0.30, 1.72], [1.28,0,0]));
  body.add(mesh (G.cone,  M.trim,  [0.36,0.74,0.36], [-0.68,-0.30, 1.72], [1.28,0,0]));
  var plow = mesh(G.box, GL, [1.74,0.09,0.11], [0, 0.10, 1.54], [-0.64,0,0]);
  body.add(plow);
  for (var f = 0; f < 3; f++)
    body.add(plate(M.armor, 1.54-0.12*f, 0.10, 0.52, [0, 0.62-0.20*f, -0.92-0.07*f], 0.62));
  body.add(mesh(G.cyl, M.trim, [0.30, 0.90, 0.30], [0, 0.30, -1.06]));

  /* 砲塔（獨立追瞄）—— 質量集中在肩線上方，60px 也讀得到它在轉 */
  var tur = new THREE.Group(); tur.userData.bone = 1; tur.position.set(0, 0.50, -0.22); body.add(tur);
  tur.add(mesh (G.tor,   M.trim,  [1.66,1.66,0.55], [0,-0.02,0], [HP,0,0]));
  tur.add(bevel(M.dark,  1.32, 0.64, 1.30, [0, 0.26, 0]));
  tur.add(plate(M.armor, 1.38, 0.36, 0.74, [0, 0.48, 0.30], -0.32));
  tur.add(rib  (M.armor, 1.42, 0.09, 0.09, [0, 0.66, 0.44], -0.32));
  tur.add(plate(M.armor, 0.26, 0.52, 0.90, [ 0.68, 0.26, -0.10], 0, -0.14, -0.16));
  tur.add(plate(M.armor, 0.26, 0.52, 0.90, [-0.68, 0.26, -0.10], 0,  0.14,  0.16));
  tur.add(mesh (G.box,   M.trim,  [0.56, 0.40, 0.44], [0, 0.30, -0.76]));
  var core = mesh(G.oct, GLA, [0.36,0.36,0.36], [0, 0.66, -0.26]);
  core.userData.noMerge = 1; tur.add(core);

  var gun = new THREE.Group(); gun.userData.bone = 1; gun.position.set(0, 0.28, 0.30); tur.add(gun);
  gun.add(bevel(M.dark, 0.72, 0.42, 0.60, [0,0,0.16]));
  var muz = [];
  for (var s = -1; s <= 1; s += 2){
    gun.add(mesh(G.cyl, M.trim,  [0.27, 1.86, 0.27], [s*0.24, 0, 0.92], [HP,0,0]));
    gun.add(mesh(G.box, M.armor, [0.13, 0.16, 1.20], [s*0.24, 0.19, 0.86]));
    var mg = mesh(G.tor, GLA, [0.46,0.46,0.7], [s*0.24, 0, 1.80]);
    mg.userData.noMerge = 1; gun.add(mg); muz.push(mg);
  }
  gun.add(mesh(G.box, GLA, [0.06, 0.06, 1.30], [0, 0.16, 0.90]));

  var legs = [walzeLeg( 1, 1, GL), walzeLeg(-1, 1, GL),
              walzeLeg( 1,-1, GL), walzeLeg(-1,-1, GL)];
  for (var i = 0; i < 4; i++) body.add(legs[i].root);

  root.userData.rig = {body:body, tur:tur, gun:gun, legs:legs, muz:muz,
                       core:core, plow:plow, GL:GL, GLA:GLA, hipY:1.78};
  return mergeBones(root);
}
function updWalzeBase(rig, o, dt){
  var ph = [0, 0.5, 0.5, 0];                 // 對角步：前左＋後右同相
  var bob = 0.055*Math.sin(o.ph*2*Math.PI * 2)*o.mv;
  rig.body.position.y = rig.hipY + bob - o.tel*0.16 + o.atk*0.06;
  rig.body.rotation.set(0.03*Math.sin(o.ph*Math.PI * 2)*o.mv - o.tel*0.06 + o.atk*0.12,
                        0, 0.035*Math.sin(o.ph*Math.PI * 2)*o.mv);
  for (var i = 0; i < 4; i++){
    var L = rig.legs[i], p = (o.ph + ph[i] + (L.sz<0?0.18:0)) % 1, fz, fy;
    if (o.mv > 0.02){
      var stride = 0.34 + o.mv*0.62, hgt = 0.10 + o.mv*0.24;
      if (p < 0.62){ fz = stride*(0.5 - p/0.62); fy = 0; }
      else { var u = (p-0.62)/0.38; fz = stride*(u-0.5); fy = hgt*Math.sin(Math.PI*u); }
    } else { fz = L.sz*0.06; fy = 0; }
    if (L.dead){ fy = 0; fz = L.sz*0.30; }   // 破壞：腿拖著走
    var q = legIK(fy + LBF - rig.body.position.y, fz);
    L.thigh.rotation.x = q.hip + (L.dead ? 0.34 : 0);
    L.shin.rotation.x  = q.knee;
    L.foot.rotation.x  = -(q.hip + q.knee) + Math.min(1, fy*3.2)*0.28;
    L.kneeGlow.visible = !L.dead;
  }
  rig.tur.rotation.y = angTo(rig.tur.rotation.y, o.aim - o.yaw, 1.5*dt);
  rig.gun.rotation.x = -0.10 - o.tel*0.24 + o.atk*0.34;
  rig.GL.emissiveIntensity  = rig.GL.userData.base  * (1 + 0.10*Math.sin(o.t*2.6) + 1.5*o.tel);
  rig.GLA.emissiveIntensity = rig.GLA.userData.base * (1 + 2.6*o.tel + 3.0*o.atk);
  rig.core.visible = !o.broken;
  for (var m = 0; m < rig.muz.length; m++){
    var k = 1 + 2.4*o.atk;
    rig.muz[m].scale.set(0.46*k, 0.46*k, 0.7);
  }
}
/* 原型 3072–3092 的補丁：WALZE / ZENIT 是最早做的兩隻，當時還沒有「階段」
   這個概念，所以二階段是**加上去**的而不是重寫。移植器把它折成
   base + wrapper 兩段（原型是在模組尾端重新指派同名變數，ESM 做不到）。 */
export function updWalze(rig, o, dt) {
  updWalzeBase(rig, o, dt);
  rig.f2 = damp(rig.f2 === undefined ? 0 : rig.f2, o.p2 ? 1 : 0, 2.4, dt);
  var f = rig.f2;
  if (rig.body) rig.body.position.y = 1.78 - 0.44*f;   // 車體下沉＝衝撞判定變大
  if (rig.tur)  rig.tur.rotation.y += dt*2.0*f;        // 砲塔自轉＝連射掃描
  if (rig.GL)   rig.GL.emissiveIntensity  = 1.8 + 2.4*f + 2.6*o.tel;
  if (rig.GLA)  rig.GLA.emissiveIntensity = 2.0 + 2.8*f + 4*o.atk*(1-o.atk);
}
